// src/admin/components/BannerCTASection.jsx

import { useTheme } from "../../context/ThemeContext";

export default function BannerCTASection({
    formData,
    updateField,
}) {

    const { isDark } = useTheme();

    const inputClass = `
        w-full
        px-4
        py-3
        rounded-2xl
        border
        outline-none
        transition-all
        ${
            isDark
                ? "bg-white/5 border-white/10 focus:border-blue-800/50"
                : "bg-white border-gray-300 focus:border-blue-800"
        }
    `;

    return (

        <section
            className={`
                rounded-3xl
                border
                p-8
                space-y-6
                ${
                    isDark
                        ? "border-white/10 bg-white/5"
                        : "border-gray-200 bg-white"
                }
            `}
        >

            <div>

                <h2 className="text-xl font-semibold">
                    Call To Action
                </h2>

                <p className="mt-1 text-sm opacity-70">
                    Configure the button users will click when viewing the advertisement.
                </p>

            </div>

            <div>

                <label className="block mb-2 font-medium">
                    CTA Button Text
                </label>

                <input
                    type="text"
                    value={formData.cta_text}
                    onChange={(e) =>
                        updateField(
                            "cta_text",
                            e.target.value
                        )
                    }
                    placeholder="e.g. Learn More"
                    className={inputClass}
                />

            </div>

            <div>

                <label className="block mb-2 font-medium">
                    CTA URL
                </label>

                <input
                    type="url"
                    value={formData.cta_url}
                    onChange={(e) =>
                        updateField(
                            "cta_url",
                            e.target.value
                        )
                    }
                    placeholder="https://example.com"
                    className={inputClass}
                />

                <p className="mt-2 text-sm opacity-70">
                    The destination users will be redirected to after clicking the banner.
                </p>

            </div>

        </section>

    );

}